// const { createSlice } = require('@reduxjs/toolkit')

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  appStore: {
    viewType: 'Global',
    expandChart: false,
    chart: 1,
    table: 1,
    legend: true,
    type: 11,
    fromDate: '',
    toDate: '',
  },
}
const mainAppSlice = createSlice({
  name: 'appStore',
  initialState,
  reducers: {
    setAppStore: (state, action) => {
      // console.log(action.payload)
      if (action.payload?.type && action.payload?.type !== 3) {
        // console.log('if')
        state.appStore = { ...state.appStore, ...action.payload, fromDate: '', toDate: '' }
      } else {
        // console.log('else')
        state.appStore = { ...state.appStore, ...action.payload }
      }
      //   console.log(state)
    },
    restAppStore: (state, action) => {
      state.appStore = {
        viewType: 'Global',
        expandChart: false,
        chart: 1,
        table: 1,
        legend: true,
        type: 11,
        fromDate: '',
        toDate: '',
      }
    },
  },
})

export const { setAppStore, restAppStore } = mainAppSlice.actions
export default mainAppSlice.reducer
